/**
*
* Map
*
*/

import React from 'react';
import { connect } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import { makeSelectEntities } from 'models/selectors';
import { makeSelectCurrentRegionId } from 'containers/App/selectors';

import { googleApiKey } from 'settings';

import Gmap from 'components/Gmap';
import { interactMap, mapDealerClick, sendRaw } from 'containers/App/metricsActions'


export class Map extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  /* istanbul ignore next */
  constructor (props) {
    super(props);
    this.state = { showDealer: null };
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
    this.filterMarkers = this.filterMarkers.bind(this);
    this.zoomLimit = this.zoomLimit.bind(this);
  }

  /* istanbul ignore next */
  componentDidMount () {
    // this.props.getDealers()
  }

  /* istanbul ignore next */
  zoomLimit = (bounds) => (map) => {
    if (map) {
      setTimeout(() => {
        map.fitBounds(bounds);
        const zoom = map.getZoom();
        if (zoom > 10) {
          // ayy
          map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(10); // eslint-disable-line no-underscore-dangle
        }
      }, 50);
    }
  }

  /* istanbul ignore next */
  filterMarkers (dealers, regionId) {
    const { regions } = this.props;
    if (regionId) {
      return dealers.filter((one) => regions[regionId].cities.includes(one.cityId));
    }
    return dealers;
  }

  /* istanbul ignore next */
  handleMarkerClick (id) {
    this.props.mapDealerClick(id)
    this.setState({ showDealer: id });
  }

  /* istanbul ignore next */
  handleMarkerClose (id) {
    this.setState({ showDealer: null });
  }

  /* istanbul ignore next */
  render () {
    const { dealers, regionId, regions, interactMap, sendRaw } = this.props;
    // console.log(dealers)
    // console.log(this.state.dealers)
    let mapDealers = Object.values(dealers);
    if (regionId && regions && regions[regionId]) {
      mapDealers = mapDealers.filter((one) => regions[regionId].cities.includes(one.cityId));
    }
    // const dealer = this.state.dealers ? this.state.dealers.filter((dealer) => dealer.showInfo === true)[0] : null
    return (
      <div style={{ height: 350 }}>
        <Gmap
          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${googleApiKey}`}
          dealers={mapDealers}
          onMarkerClick={this.handleMarkerClick}
          onMarkerClose={this.handleMarkerClose}
          zoomLimit={this.zoomLimit}
          showDealer={this.state.showDealer}
          interactMap={interactMap}
          sendRaw={sendRaw}
          loadingElement={(
            <div style={{ height: '100%' }}>
                  Загрузка
            </div>
          )}
          containerElement={
            <div style={{ height: '100%' }} />
          }
          mapElement={
            <div style={{ height: '100%' }} />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  dealers: makeSelectEntities('dealers'),
  regions: makeSelectEntities('regions'),
  regionId: makeSelectCurrentRegionId(),
});

function mapDispatchToProps (dispatch) {
  return {
    interactMap: payload => dispatch(interactMap(payload)),
    mapDealerClick: payload => dispatch(mapDealerClick(payload)),
    sendRaw: (c, a, l) => dispatch(sendRaw(c, a, l)),
    // getDealers: () => dispatch(getDealers()),
    // chooseDealer: (id) => dispatch(chooseMapDealer(id)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Map);
